<template>
  <CRow>
    <CCol col="12" lg="12">
      <div class="detail-div">
        <CRow>
          <div>
            <CModal :title="submitType === 'Update' ? $lang.post.crud.edit : $lang.common.general.reason" size="lg"
              :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <c-textarea v-model="need.reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
                  </CCol>
                  <CCol md="6">
                    <div class="form-group">
                      <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.submit" :disabled="submitted"
                        v-on:click="blockPost(statusId)">
                        Submit
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
              <template #footer style="display: none">
                <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
                <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
              </template>
            </CModal>
          </div>
        </CRow>
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.need.form.user }}
            </p>
            <p class="custome-detail">
              <ProfilerDetail :username="need.name" :profilerId="need.createdBy"></ProfilerDetail>
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">Required Date</p>
            {{ need.requiredDate }}
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">Address</p>
            {{ need.address }}
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">Company Name</p>
            {{ need.companyName }}
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">Need Type</p>
            {{ need.studentNeedTypeName }}
          </CCol>
          <CCol sm="12" md="12" lg="12">
            <p class="custome-labal">{{ $lang.need.form.description }}</p>
            <Description :title="$lang.need.form.description" :content="need.description" :length="90" />
          </CCol>
        </CRow>
        <EntityTimeStamp :createdAt="need.createdAt" :updatedAt="need.updatedAt"></EntityTimeStamp>
        <!-- <CRow v-show="need.blockedReason">
          <CCol sm="12" align="left">
            <strong>Blocked Reason: </strong> {{ need.blockedReason }}
          </CCol>
        </CRow> -->
        <!-- <CRow v-if="!need.blockedReason && need.isStatus != 'Closed'">
            <CCol sm="12" align="left">
              <CButton :color="statusColor" v-c-tooltip="statusLabel" v-on:click="beforeBlocked()">
                {{ statusLabel }}
              </CButton>
            </CCol>
        </CRow> -->
      </div>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import BranchComponent from "/src/views/branch/Component";
import {
  opportunity,
  industry,
  duration,
  currencytype,
  users,
  skills,
} from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import VueToasted from "vue-toasted";
import moment from "moment";
import Description from "/src/views/Description";
import ProfilerDetail from "/src/views/ProfilerDetail.vue";
import { serverBus } from "/src/main";
import EntityTimeStamp from "/src/components/EntityTimeStamp";

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "NeedEdit",
  mixins: [Mixin],
  components: {
    Description,
    ProfilerDetail,
    EntityTimeStamp,
    BranchComponent
  },
  data() {
    return {
      submitType: "",
      userId: "",
      largeModal: false,
      statusId: "",
      statusLabel: "Block",
      statusColor: "danger",
      submitted: false,
      showTax: true,
      err_msg: "",
      dismissCountDown: 0,
      postTypeList: [],
      statusOption: [],
      industryOptions: [],
      subIndustryOptions: [],
      resourceTypeOptions: [],
      currencyOptions: [],
      durationOptions: [],
      remoteWorkOptions: [],
      userOptions: [],
      skillsOptions: [],
      selectedSkills: [],
      getSkills: [],
      self: this,
      module: opportunity,
      moduleIndustry: industry,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      moduleSkills: skills,
      moduleUser: users,
      need: {
        name: "",
        branchInfo: "",
        description: "",
        remoteWork: "",
        subIndustry: "",
        currency: "",
        duration: "",
        industry: "",
        isActive: 1,
        budget: "",
        user: "",
        skills: "",
        status: "",
        ratingLabel: "",
        company: "",
        isStatus: "",
        whose: "",
        reason: "",
        symbol: "",
        userWithCompany: "",
        createdAt: '',
        updatedAt: '',
        blockedReason: '',
        min_budget: '',
        max_budget: '',
        opportunityType: '',
        date: '',
        createdBy:"",
        requiredDate:"",
        address:"",
        companyName:"",
        studentNeedTypeName:""
      },
    };
  },

  mounted() {
    store.commit("showLoader", true);
    const type = {
      YES: "Yes",
      NO: "No",
    };
    let self = this;
    self.statusOption.push(
      { value: "1", label: "Active" },
      { value: "0", label: "InActive" },
      { value: "2", label: "Block" },
      { value: "3", label: "Closed" },
      { value: "4", label: "Draft" }
    );
    self.dismissCountDown = 0;
    const id = this.$route.params.id;

    self.remoteWorkOptions.push(
      { value: type.YES, label: type.YES },
      { value: type.NO, label: type.NO }
    );
    self.dismissCountDown = 0;
    self.editId = id;
    axios
      .get('need/view/'+id)
      .then((response) => {
        if (response.data) {
          const responseData = response.data.data;
          self.need.date = responseData.startDate; //  moment(responseData.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
          self.need.name = (responseData.userName !== "") ? responseData.userName : '-';
          self.need.ratingLabel = responseData.ratingLabel;
          self.need.description = (responseData.description !== "") ? responseData.description : '-';
          self.need.budget = responseData.budget ?? '-';
          self.need.isActive = responseData.isActive;
          self.need.isStatus = responseData.isActiveStatus;
          self.need.visibility = responseData.visibility;
          self.need.showToOther = responseData.showToOther;
          self.need.branchInfo = responseData.branchInfo;
          self.need.createdBy = responseData.createdBy;
          self.need.requiredDate = responseData.requiredDate;
          self.need.address = responseData.address;
          self.need.companyName = responseData.companyName;
          self.need.studentNeedTypeName = responseData.studentNeedTypeName;
          self.need.blockedReason = responseData.blockedReason;

          if (self.need.isStatus === "Active") {
            self.need.isStatus = 'Open';
            // console.log(this.getStatusLabel(2));
            self.statusLabel = this.getStatusLabel(2);
            self.statusId = "2";
            self.statusColor = "danger";
          } else {
            self.statusId = "1";
            self.statusLabel = this.getStatusLabel(1);
            self.statusColor = "success";
          }

          self.need.remoteWork = responseData.remoteWork;
          self.need.max_budget = responseData.maxBudget;
          self.need.min_budget = responseData.minBudget;
          self.need.opportunityType = responseData.opportunityType;
          self.need.remoteWorkAddress = responseData.remoteWorkAddress;
          self.need.isGST = responseData.isGST ?? '-';
          self.need.tax = responseData.GstTax;
          if (responseData.isGST === "No") {
            self.showTax = false;
          }
          self.need.status = {
            value: responseData.isActive,
            label: responseData.isActiveStatus,
          };

          self.need.industry = responseData.industry ? {
            value: responseData.industry.id,
            label: responseData.industry.title,
          } : '';

          const servicesList = [];
          responseData.subindustry.map(function (value, key) {
            servicesList.push(value.title);
          });
          self.need.subIndustry = servicesList.join(", ");

          self.need.duration = responseData.duration ? responseData.duration.value : '-';
          self.need.currency = responseData.currency ?? '';
          self.need.symbol = responseData.currency ? responseData.currency.symbol : '';

          self.need.whose = responseData.user.whose;
          if (responseData.user.company)
            self.need.user = responseData.user.company;
          else if (responseData.user.name)
            self.need.user = responseData.user.name;

          self.need.userWithCompany = responseData.user.userWithCompany;
          self.need.userId = responseData.userId;
          self.need.createdAt = responseData.createdAt;
          self.need.updatedAt = responseData.updatedAt;

          const list = [];
          responseData.skills.map(function (value, key) {
            list.push(value.title);
          });
          self.need.skills = list.join(", ");

          store.commit("showLoader", false); // Loader Off
        }
      })
      .catch(function (error) {
        store.commit("showLoader", false); // Loader Off
      });
  },
  methods: {
    showProfile(userId) {
      serverBus.$emit("profilerId", userId);
    },

    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },

    beforeBlocked() {
      let self = this;
      self.need.reason = "";
      // console.log(self.opportunity);
      if (self.need.isActive === 1) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },

    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.need.isActive === 1) {
        if (self.need.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;

            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.need.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }

              axios
                .post(this.statusUrlWeb(this.module, id), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.need.isStatus = status;
                    self.statusLabel = button;
                    self.largeModal = false;
                    self.submitted = false; //Enable Button
                    self.$router.go();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = false; //Enable Button
                });
            }, 500);
          }
        });
      } else {
        const id = this.$route.params.id;
        let self = this;
        const postData = {
          status: statusId,
          reason: "",
        };
        let status, button;
        if (self.statusId === "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
          .post(this.statusUrlWeb(this.module, id), postData)
          .then(function (response) {
            if (response.data.code === 200) {
              self.need.isStatus = status;
              self.statusLabel = button;
              self.largeModal = false;
              self.submitted = false; //Enable Button
              self.$router.go();
            } else {
              self.err_msg = response.data.message;
              self.dismissCountDown = 10;
            }
          })
          .catch(function (error) {
            self.submitted = false; //Enable Button
          });
      }
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
